<script>
import PostCard from "../PostCard.vue";

export default {
  props: {
    posts: {
      type: Array,
      required: true,
    },
  },
  components: {
    PostCard,
  },
  data() {
    return {
      activePost: 0,
    };
  },
  methods: {
    scrollToPost(e) {
      const target = e.target;
      if (!target.classList.contains("dot")) return;

      const index = Array.from(this.$refs.carouselControl.children).indexOf(
        target
      );

      const selector = `#carousel-item-${this.posts[index].id}`;
      const element = document.querySelector(selector);

      this.activePost = index;
      element.scrollIntoView({
        behavior: "smooth",
        inline: "start",
        block: "nearest",
      });
    },
    scrollHandler(e) {
      // https://stackoverflow.com/a/68307859/16011210
      const carousel = this.$refs.carousel;

      // const atSnappingPoint = carousel.scrollLeft % carousel.clientWidth === 0;
      // const timeOut = atSnappingPoint ? 0 : 100;
      clearTimeout(e.target.scrollTimeout);

      e.target.scrollTimeout = setTimeout(() => {
        // scrolling stopped
        const index = Math.round(carousel.scrollLeft / carousel.clientWidth);
        this.activePost = index;
      }, 0);
    },
  },
  mounted() {
    this.$refs.carousel.addEventListener("scroll", this.scrollHandler);
  },
  beforeDestroy() {
    this.$refs.carousel.removeEventListener("scroll", this.scrollHandler);
  },
};
</script>

<template>
  <div class="carousel-container">
    <ul
      ref="carousel"
      class="h-posts-carousel"
      role="region"
      aria-roledescription="carousel"
      aria-label="Hervorgehobene Beiträge"
    >
      <li class="h-posts-carousel-item" v-for="post in posts" :key="post.id">
        <PostCard
          :post="post"
          aria-roledescription="Slide"
          :aria-labelledby="`carousel-item-${post.id}__heading`"
          :id="`carousel-item-${post.id}`"
        />
      </li>
    </ul>

    <div
      v-if="posts.length > 1"
      ref="carouselControl"
      class="dots"
      role="group"
      aria-label="Schieberegler"
      @click="(e) => scrollToPost(e)"
    >
      <button
        class="dot"
        v-for="(post, index) in posts"
        :key="post.id"
        :class="{ 'dot--active': index === activePost }"
      >
        <span class="visually-hidden">
          Zeige Beitrag {{ index + 1 }} von {{ posts.length }}: {{ post.name }}
        </span>
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.carousel-container {
  position: relative;
  padding: 0 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: calc(15px - 8px); // expected gap - padding bottom
  width: 100%;
  max-width: 440px;
}

.h-posts-carousel {
  display: flex;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  gap: 20px;
  width: 100%;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-left: 8px;
  padding-right: 8px;

  overflow-x: scroll;
  box-sizing: content-box;

  /* Hiding scrollbar */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */

  /* WebKit */
  &::-webkit-scrollbar {
    -webkit-appearance: none;
    display: none;
    height: 0;
  }
}

@supports (-webkit-overflow-scrolling: touch) {
  .h-posts-carousel {
    -webkit-overflow-scrolling: touch;
  }
}

.h-posts-carousel-item {
  scroll-snap-align: center;
  flex-shrink: 0;
  width: 100%;
  list-style-type: none;
}

.dots {
  display: flex;
  justify-content: center;
  gap: 7px;
}

.dot {
  all: unset;
  height: 8px;
  width: 8px;
  border-radius: 9999px;
  background-color: rgba(0, 0, 0, 0.2);

  &--active {
    background-color: rgba(0, 0, 0, 1);
  }

  &:focus-visible {
    outline-offset: 0px !important;
  }
}

.visually-hidden {
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}
</style>
